import React from 'react'
import Footer from '../components/Footer'
import Header from '../components/Header'
import '../style/shop.scss'

const Sneaker = () => {
  return (
    <div>
      <Header/>
      <div>
        <div className='shop-now'>
          <div className='shop-now-title'>
            <h2>Sneakers</h2>
            <img src='https://wallpapers.net/web/wallpapers/inspirational-nature/5120x2160.jpg'/>
          </div>
          <div className='shop-now-menu'>
              <li>New Arrivals</li>
              <li>Best Seller</li>
              <li>Boots</li>
              <li>Sneakers</li>
          </div>
        </div>
          <div className='shop-now-item'>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
          </div>
          <div className='shop-now-item'>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
          </div>
          <div className='shop-now-item'>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
          </div>
          <div className='shop-now-item'>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
          </div>
          <div className='shop-now-item'>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
            <div className='item-shop'>
              <div className='item-shop-img'></div>
              <div className='item-shop-title'>
                <p>Paradiso Retro Sneaker</p>
                <p>$129</p>
              </div>
            </div>
          </div>
      </div>
      <Footer/>
    </div>
  )
}

export default Sneaker